export default "__VITE_ASSET__Bn_Vi8Ip__"